import React from "react";
import { useCSVReader } from "react-papaparse";
import { CSVLink } from "react-csv";

export default function CsvUploader({
  handleOnDrop,
  handleRemove,
  downloadTemplate,
}) {
  const { CSVReader } = useCSVReader();
  const header = [
    { label: "SN", key: "SN" },
    { label: "MATRICNO", key: "MATRICNO" },
    { label: "LASTNAME", key: "LASTNAME" },
    { label: "FIRSTNAME", key: "FIRSTNAME" },
    { label: "OTHERNAME", key: "OTHERNAME" },
    { label: "PROGRAMME", key: "PROGRAMME" },
    { label: "SET", key: "SET" },
    { label: "YEAR OF GRAD", key: "YEAR OF GRAD" },
    { label: "UNOFFICIAL TRANSCRIPT", key: "UNOFFICIAL TRANSCRIPT" },
    { label: "HOME ADDRESS", key: "HOME ADDRESS" },
    { label: "EMAIL ADDRESS", key: "EMAIL ADDRESS" },
    { label: "PHONE NO", key: "PHONE NO" },
    { label: "Alumni Dues 2014", key: "Alumni Dues 2014" },
    { label: "Alumni Dues 2015", key: "Alumni Dues 2015" },
    { label: "Alumni Dues 2016", key: "Alumni Dues 2016" },
    { label: "Alumni Dues 2017", key: "Alumni Dues 2017" },
    { label: "Alumni Dues 2018", key: "Alumni Dues 2018" },
    { label: "Alumni Dues 2019", key: "Alumni Dues 2019" },
    { label: "Alumni Dues 2020", key: "Alumni Dues 2020" },
    { label: "Alumni Dues 2021", key: "Alumni Dues 2021" },
    { label: "Alumni Dues 2022", key: "Alumni Dues 2022" },
    { label: "Alumni Dues 2023", key: "Alumni Dues 2023" },
  ];

  return (
    <CSVReader>
      {({ getRootProps, acceptedFile, ProgressBar, getRemoveFileProps }) => (
        <>
          <div>{acceptedFile && acceptedFile.name}</div>
          <div className="flex mt-5 justify-center">
            <button
              className="rounded-l-md bg-gray-500 p-1 text-white"
              onClick={() => handleRemove()}
            >
              Remove
            </button>
            <CSVLink
              data={[]}
              headers={header}
              filename={"template.csv"}
              target="_blank"
              className=" bg-gray-500 p-1 text-white ml-1"
            >
              <button
                type="download"
                // onClick={() => downloadTemplate()}
              >
                Template
              </button>
            </CSVLink>
            <div className="flex">
              <label className="cursor-pointer rounded-r-md bg-gray-500 p-1 text-white ml-1">
                Browse file
                <input
                  type="file"
                  className="opacity-0 w-0"
                  accept=".csv"
                  // accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={(e) => handleOnDrop(e)}
                />
              </label>
            </div>
          </div>
          <ProgressBar />
        </>
      )}
    </CSVReader>
  );
}
